import { useQuery } from '@tanstack/react-query';
import { api } from './api';

/** Ringkasan lisensi dari GET /license (hanya ada pada instalasi self-hosted). */
export interface LicenseInfo {
  selfHosted: true;
  customer: string;
  licenseId: string;
  issuedAt: string;
  updatesUntil: string;
  updatesActive: boolean;
  updatesDaysLeft: number;
  releaseDate: string | null;
  features: string[];
  limits: { outlets: number; devices: number; employees: number };
  note: string | null;
}

/** Konfigurasi publik server: instalasi SaaS atau self-hosted (menentukan layar masuk & menu Lisensi). */
export function usePublicConfig() {
  return useQuery({
    queryKey: ['public-config'],
    staleTime: Infinity,
    retry: false,
    queryFn: () =>
      api.get<{ deployment: 'saas' | 'selfhosted'; registrationEnabled: boolean }>(
        '/public/config',
      ),
  });
}
